import React from 'react';
export const LoadingState = () => {
  return <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-80 z-[25]" data-id="element-261">
      <div className="text-center" data-id="element-262">
        <div className="inline-block w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" data-id="element-263"></div>
        <p className="mt-3 text-gray-800 font-medium" data-id="element-264">লোড হচ্ছে...</p>
        <p className="text-sm text-gray-600" data-id="element-265">(Loading...)</p>
      </div>
    </div>;
};